<template>
  <div>
    <template v-if="isDocumentTemplateLoading">
      <Loading />
    </template>
    <template v-else>
      <template v-if="getDocumentTemplates && getDocumentTemplates.length">
        <!-- START DESKTOP ROW -->
        <div
          class="hidden md:flex flex-row rounded-lg bg-white px-5 py-5 my-5 forms-row"
          v-for="template in getDocumentTemplates"
          :key="template.slug"
        >
          <div class="w-1/5 pr-2">
            <div class="flex flex-col justify-center h-full w-full">
              <div class="flex items-center py-1">
                <h5 class="text-base font-normal truncate md:max-w-4xs lg:max-w-3xs xl:max-w-2xs">
                  {{ template.name || "No document name" }}
                </h5>
              </div>
            </div>
          </div>

          <div class="w-1/5 flex flex-col justify-center pr-2">
            <p
              class="text-brand-gray text-sm truncate"
              v-for="(at, idx) in template.attachments.slice(0, 2)"
              :key="`${template.slug}-at-${idx}`"
            >
              {{ at.name }}
            </p>
            <p class="text-brand-gray text-sm truncate" v-if="template.attachments.length > 2">
              + {{ template.attachments.length - 2 }} more
            </p>
          </div>

          <div class="w-1/5 flex flex-col justify-center pr-2">
            <p class="text-brand-green truncate" v-if="template.linked_form">
              ...net/{{ template.linked_form }}
            </p>
          </div>

          <div class="w-1/10 px-2 flex items-center">
            <CheckIcon class="w-8 h-8 text-brand-green" v-if="template.has_required_signature" />
          </div>

          <div class="w-1/10 px-2 flex items-center">
            <div class="flex items-center h-full px-1 mr-5">
              <router-link
                :to="{
                  name: 'dashboard_documents_edit',
                  params: { id: template.id }
                }"
              >
                <PencilAltIcon
                  class="w-8 h-8"
                  :class="[
                    template
                      ? 'text-brand-green cursor-pointer'
                      : 'text-brand-gray pointer-events-none'
                  ]"
                />
              </router-link>
            </div>

            <router-link
              :to="{
                name: 'dashboard_documents_view',
                params: { id: template.id }
              }"
            >
              <EyeIcon class="w-8 h-8 text-brand-green cursor-pointer" />
            </router-link>
          </div>

          <div class="w-1/10 px-2 flex items-center ml-5">
            <div class="flex items-center h-full w-full">
              <PrimaryButton @click="openSendModal(template)">Send</PrimaryButton>
            </div>
          </div>
        </div>
        <!-- END DESKTOP ROW -->

        <div class="flex justify-end" v-if="getDocumentTemplatesTotalCount > 0">
          <Pagination
            :current="getDocumentTemplatesCurrentPage"
            :total="getDocumentTemplatesTotalCount"
            :per-page="25"
            @page-changed="loadTemplates"
          />
        </div>
      </template>
      <template v-else>
        <div class="flex flex-col px-3 py-3 md:py-10 md:items-center justify-center empty-state">
          <div class="w-1/3 md:w-1/6 mx-auto">
            <Lottie :animationData="formEmptyAnimationData" />
          </div>
          <h2 class="py-1 px-2 pb-5 text-xl md:text-3xl text-center">
            Looks like you don't have any documents yet.
          </h2>

          <div class="flex items-center justify-center py-3">
            <router-link :to="{ name: 'dashboard_new_document_name' }">
              <PrimaryButton>
                <div class="flex flex-row items-center justify-center py-1 w-48">
                  <div class="flex items-center mr-2">
                    <PlusIcon class="text-white w-5 h-5" />
                  </div>
                  <div class="flex items-center">
                    <p class="text-white">Upload New</p>
                  </div>
                </div>
              </PrimaryButton>
            </router-link>
          </div>
          <p class="py-2 text-center">
            Click the "Upload New" button to create your document signing template and send them to
            external parties.
          </p>
        </div>
      </template>
    </template>
  </div>

  <SendModal :showModal="showSendModal" @close="closeShareModal" :template="selectedTemplate" />
</template>
<script>
import { EyeIcon, PencilAltIcon, CheckIcon, PlusIcon } from "@heroicons/vue/outline"

import SendModal from "./SendModal.vue"

import { mapGetters } from "vuex"
import { DOCUMENT_TEMPLATE_GET_LIST } from "@/store/types"

import FormsEmpty from "@/assets/animations/forms-empty.json"

export default {
  components: {
    EyeIcon,
    PencilAltIcon,
    CheckIcon,
    PlusIcon,
    SendModal
  },
  computed: {
    ...mapGetters([
      "isDocumentTemplateLoading",
      "getDocumentTemplates",
      "getDocumentTemplatesTotalCount",
      "getDocumentTemplatesCurrentPage"
    ])
  },
  data() {
    return {
      showSendModal: false,
      selectedTemplate: null,
      formEmptyAnimationData: FormsEmpty
    }
  },
  mounted() {
    this.loadTemplates()
  },
  methods: {
    closeShareModal() {
      this.showSendModal = false
    },
    openSendModal(template) {
      this.showSendModal = true
      this.selectedTemplate = template

      //this.$store.dispatch()
    },
    loadTemplates(page) {
      this.$store.dispatch(DOCUMENT_TEMPLATE_GET_LIST, { page })
    }
  }
}
</script>
